import { useRouter } from 'next/router'
import type { SWRResponse } from 'swr'
import useSWR from 'swr'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import type { CommunityWithTopicsInterface } from 'modules/community/types/community-interface'

export function useCommunityWithTopics(): SWRResponse<
  CommunityWithTopicsInterface,
  unknown,
  unknown
> {
  const router = useRouter()
  const { user } = useUser()
  const { communityPath } = router.query

  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    CommunityWithTopicsInterface
  >({
    method: RequestMethodsEnum.get,
    unauthorizedResponseHandler: error => {
      throw error
    },
  })

  const getCommunityWithTopicsQuery = useSWR(() => {
    if (communityPath && user) {
      return `${COMMUNITY_API_PREFIX}/${communityPath}`
    }
    return null
  }, fetcher)

  return getCommunityWithTopicsQuery
}
